import { TEDLRFakturaAttestSTATUSEnum } from '../../../../../../../../globalQueryTypes';
import {
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All__Associations_Attestratt,
} from '../../../Queries/_QueryTypes/FakturaDelQuery';
import { AllCertifiers_db_LRAttestratt_All } from '../Queries/_QueryTypes/AllCertifiers';

export const haveUnCertifiedCertifiers = (
  certifierState: AllCertifiers_db_LRAttestratt_All[],
  certificates: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[]
): boolean => {
  let result = false;
  //Loopa igenom state och kolla mot certificates om den har attesterat eller inte
  for (let index = 0; index < certifierState.length; index++) {
    const changedCertifier = certifierState[index];

    result = !certificates.some(
      value =>
        value?.STATUS === TEDLRFakturaAttestSTATUSEnum.ATTESTERAD &&
        value?.AttestantSign ===
          changedCertifier?._Associations?.Attestant?.SIGNATUR &&
        value?._Associations?.Attestratt?._Associations?.Attestomrade?.KOD ===
          changedCertifier?._Associations.Attestomrade?.KOD
    );

    if (result == true) {
      //Har ej attesterat
      return result;
    }
  }

  return result;
};

export const isAttestanterUnique = (
  desicionState: AllCertifiers_db_LRAttestratt_All[],
  recieverState: AllCertifiers_db_LRAttestratt_All[]
): boolean => {
  let result = true;
  for (let index = 0; index < desicionState.length; index++) {
    const desicionCertificates = desicionState[index];
    result = !recieverState.some(
      recieverCertificates =>
        recieverCertificates.id === desicionCertificates.id
    );
    if (result === false) {
      return result;
    }
  }

  return result;
};

export const getCurrentCertifiers = (
  loading: boolean,
  allCertifierData: AllCertifiers_db_LRAttestratt_All[],
  certifiers: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All__Associations_Attestratt[]
) => {
  if (loading || allCertifierData.length === 0) {
    return [];
  }

  return certifiers.map(
    certifier => allCertifierData.filter(data => data.id === certifier.id)[0]
  );
};
